export default "__VITE_ASSET__B13ZwiAp__"